import React from "react";
import { observable, toJS } from "mobx";
import { sortCaret, IconeCarregar, StatusWarning } from "../../comum/components/Icones";
import { formatarDataCustomHTML, formatarDiaMesAnoCustomHTML, situacaoFormatter } from "../../../utils/formatar";
import { buscaFiltrarVazio, buscaSemResultado } from "../../../utils/mensagens";
import { Button } from "reactstrap";

export default class AnaliseCriticaStore {

    @observable analiseLista;
    @observable listaMensagens;
    @observable filtrosPreenchidos;

    @observable lista;
    @observable items;
    toShow;
    turn;
    @observable hasMore;
    @observable noData;
    @observable linhaExpandida;
    @observable tableMessage;
    @observable loading;

    @observable modalInativar;
    @observable inativandoLoading;

    @observable colunasExportacao;

    @observable cadastrar;
    @observable editar;
    @observable enviar;

    @observable modalObsFluxo
    @observable modalObsAnalise
    @observable modalObsSituacao

    constructor(service) {
        this.analiseLista = [];
        this.listaMensagens = false;

        this.colunas = this.todasColunas;

        // Scroll infinito
        this.lista = [];
        this.toShow = 20;
        this.turn = 0;
        this.items = [];
        this.hasMore = false;
        this.noData = <IconeCarregar tamanho="2x" />;
        this.tableMessage = buscaFiltrarVazio;
        this.loading = false;
        this.modalObsFluxo = false
        this.modalObsAnalise = null
        this.modalObsSituacao = null


        // Area da inativação
        this.modalInativar = false;
        this.inativandoLoading = false;

        this.service = service;

        this.cadastrar = false;
        this.editar = false;
        this.enviar = false;

        this.formatarColunasExportacao();

        this.editaveis = ["D", "R", "P"]
        this.naoMostrarObs = ["A", "E"]
    };
 
    carregarAnalises = (filtros) => {
        if (filtros) {
            this.filtrosPreenchidos = filtros;
        }
        this.fazerListar(this.filtrosPreenchidos);
    };

    formatarFiltros = (filtros) => {
        if (filtros.hasOwnProperty('status') && filtros['status'].hasOwnProperty('value')) {
            filtros['status'] = filtros['status']['value'];
        }
        return filtros;
    };

    fazerListar = (filtros) => {
        let filtrosFormat = this.formatarFiltros(filtros);

        this.analiseLista = [];
        this.lista = [];
        this.items = [];
        this.loading = true;
        this.service.listar(filtrosFormat).then(response => {
            this.loading = false;
            if (response.data) {
                this.analiseLista = response.data;
            }
            if (this.analiseLista.length === 0) {
                this.tableMessage = buscaSemResultado
            } else {
                this.tableMessage = buscaFiltrarVazio
            }
            this.lista = this.analiseLista;

            this.noData = this.tableMessage;
            this.loadFirstTurn();
        });
    };

    loadFirstTurn = () => {
        this.items = this.analiseLista.slice(0, this.toShow);
        this.turn = 1;
        this.hasMore = this.items.length < this.lista.length;
    };

    loadNextTurn = () => {
        this.items = [];
        this.items = this.lista.slice(0, (this.turn + 1) * this.toShow);
        this.turn = this.turn + 1;

        this.hasMore = this.items.length < this.lista.length;
    };

    // Exportar
    getLista() {
        return this.analiseLista;
    }
    getListaCopia() {
        return toJS(this.analiseLista)
    }

    formatarColunasExportacao = () => {
        this.colunasExportacao = this.todasColunas.slice(0, -3);
    };
    // Fim Exportar

    renderAcaoBtn = (row, label) => {
        if(!row) return null
        return row.IndStatus && this.editaveis.includes(row.IndStatus) ?
            <Button className="btn-acao" outline color="secondary" onClick={ () => this.onClickTabela(row.AnaliCritId, label) }  ativo={row.marcado}>{label}</Button>
            :
            <div className="text-center">---</div>;
    };

    renderIconeObsFluxo = (row) => {
        if(!row) return null
        if(toJS(row.ListaAnaliseCriticaHistorico).length === 0 || this.naoMostrarObs.includes(row.IndStatus)){
            return null
        } else {
            return (
                <span className="botao" id={`ObsFluxo_${row.AnaliCritId}`}>
                    <StatusWarning width={28} height={28} />
                </span>
            )
        }
    }

    onClickTabela = (id, label) => {
        if (label === "Enviar") {
            this.alternarModalEnviar(id)
        } else if (label === "Editar") {
            this.alternarModalEditar(id);
        }
    };

    alternarModalCadastrar = () => {
        this.cadastrar = !this.cadastrar;
    };

    alternarModalEditar = (id) => {
        this.editar = id ? id : false;
    };

    alternarModalEnviar = (id) => {
        this.editar = false
        this.enviar = id ? id : false;
    };

    fecharModal = () => {
        this.cadastrar = false;
        this.editar = false;
        this.enviar = false;
    };

    abrirObsFluxo = (obs, row) => {
        if(obs && toJS(row.ListaAnaliseCriticaHistorico).length > 0 && !this.naoMostrarObs.includes(row.IndStatus)){
            this.modalObsFluxo = obs
            const analise = this.analiseLista.find(analise => analise.AnaliCritId === obs)
            this.modalObsAnalise = analise.ListaAnaliseCriticaHistorico
            this.modalObsSituacao = analise.IndStatus
        }

    }

    fecharObsFluxo = () => {
        this.modalObsAnalise = null
        this.modalObsSituacao = null
        this.modalObsFluxo = false

    }

    todasColunas = [{
        dataField: 'AnaliCritId',
        text: 'Código',
        sort: true,
        sortCaret: sortCaret,
        headerAlign: (column, colIndex) => 'left'
    }, {
        dataField: 'Fantasia',
        text: 'Cliente',
        sort: true,
        sortCaret: sortCaret,
        headerAlign: (column, colIndex) => 'left'
    }, {
        dataField: 'DscMerc',
        text: 'Mercadoria',
        sort: true,
        sortCaret: sortCaret,
        headerAlign: (column, colIndex) => 'left',
        headerStyle: () => {
            return { width: "300px" };
        },
    }, {
        dataField: 'Ncm',
        text: 'NCM',
        sort: true,
        sortCaret: sortCaret,
        headerAlign: (column, colIndex) => 'left'
    }, {
        dataField: 'DtIncl',
        text: 'Inclusão',
        sort: true,
        formatter: formatarDataCustomHTML,
        sortCaret: sortCaret,
        headerAlign: (column, colIndex) => 'left',
        style: {width: '150px'}
    }, {
        dataField: 'DtUltimoEnvio',
        text: 'Último Envio',
        sort: true,
        formatter: formatarDiaMesAnoCustomHTML,
        sortCaret: sortCaret,
        headerAlign: (column, colIndex) => 'left',
        style: {width: '150px'}
    }, {
        dataField: 'IndStatusDsc',
        text: 'Situação',
        headerStyle: () => { return { maxWidth: "60px" }; },
        formatter: situacaoFormatter,
        style: {width: '200px'},
        sort: true,
        sortCaret: sortCaret
    },
    {
        dataField: 'ListaAnaliseCriticaHistorico',
        text: '',
        style: { width: '70px' },
        sort: true,
        isDummyField: true,
        formatter: (cell, row) => this.renderIconeObsFluxo(row),
        events: { onClick: (e, column, columnIndex, row, rowIndex) => this.abrirObsFluxo(row.AnaliCritId, row) }
    },
    {
        dataField: 'aprovar',
        isDummyField: true,
        text: "Aprovação",
        formatter: (cell, row) => this.renderAcaoBtn(row, "Enviar"),
        cardFormatter: (cell, row) => this.renderAcaoBtn(row, "Enviar"),
    },
    {
        dataField: 'acao',
        isDummyField: true,
        text: "Ação",
        formatter: (cell, row) => this.renderAcaoBtn(row, "Editar"),
        cardFormatter: (cell, row) => this.renderAcaoBtn(row, "Editar"),
    }];

}



// WEBPACK FOOTER //
// ./src/modules/analise/stores/AnaliseCriticaStore.js